import script from "./Overlay.vue?vue&type=script&setup=true&lang=js"
export * from "./Overlay.vue?vue&type=script&setup=true&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=3511a594&scoped=true&lang=css"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3511a594"]])

export default __exports__